<template>
    <b-modal
        ref="modalEmailPayment"
        title-tag="h2"
        :title="'Email Receipt ' + paymentName"
        lazy
    >
        <b-form-group label-for="to" label="To:" label-cols="3">
            <recepient-email
                v-model="selectedReceivers"
                :client="client"
                @input="value => handleRecipientChange(value, editableDivId)"
            ></recepient-email>
        </b-form-group>

        <b-form-group label-for="subject" label="Subject:" label-cols="3">
            <b-form-input
                id="subject"
                v-model="subject"
                placeholder="Subject (optional)"
                name="subject"
            ></b-form-input>
        </b-form-group>

        <b-form-group label-for="message" label="Message:" label-cols="3">
            <editable
                :id="editableDivId"
                ref="editable"
                :value.sync="message"
            ></editable>
        </b-form-group>

        <template v-slot:modal-footer>
            <modal-footer
                :is-loading="isLoading"
                ok-title="Send"
                @ok-action="send"
                @cancel-action="close"
            />
        </template>
    </b-modal>
</template>
<script type="text/javascript">
import { forEach, isEmpty, find } from "lodash";
import Email from "@/services/email";
import CEMAIL from "@/constants/email";
import EmailMixins from "@/mixins/email";
import BillingPaymentServices from "@/services/billing/billing-payments";

export default {
    components: {
        recepientEmail: () =>
            import("@/components/commons/recipients-email.vue"),
        editable: () => import("@/components/elements/editable"),
        modalFooter: () => import("@/components/elements/modal-footer")
    },
    mixins: [EmailMixins],
    props: {
        payment: {
            default: null
        },
        client: {
            default: null
        }
    },
    data() {
        return {
            selectedReceiver: null,
            selectedReceivers: [],
            subject: null,
            message: null,
            recipientList: [],
            receiverNames: "",
            isLoading: false
        };
    },
    computed: {
        isOkDisabled() {
            return (
                this.message == null ||
                this.message == "" ||
                this.selectedReceivers.length < 1
            );
        },
        paymentName() {
            return this.payment ? this.payment.name : "";
        },
        editableDivId() {
            return "email-message";
        }
    },
    methods: {
        open() {
            this.$refs.modalEmailPayment.show();
            this.$nextTick(() => {
                this.getEmailTemplate();
            });
        },
        getEmailTemplate() {
            let emailType = CEMAIL.TYPE.RECEIPT;
            if (
                this.payment &&
                ((!isEmpty(this.payment.charitable_funds) &&
                    find(this.payment.charitable_funds, fund => {
                        return fund.debit > 0;
                    })) ||
                    (isEmpty(this.payment.invoices) &&
                        !isEmpty(this.payment.credit)))
            ) {
                emailType = CEMAIL.TYPE.DEPOSIT;
            }
            let params = {
                business_id: this._setting.business.id,
                user_id: this.$root.currentActor.id,
                email_type: emailType,
                client_id: this.client ? this.client.id : "",
                payment_id: [this.payment.id]
            };

            Email.renderEmailMessage(params).then(response => {
                this.emailDefault = response.resources;
                this.setDetails(response.resources.message);
            });
        },
        setDetails(defaults) {
            let self = this;

            this.subject = defaults.subject;
            this.message = self.setNamesElement(defaults.message);

            setTimeout(function () {
                self.handleRecipientChange(
                    self.selectedReceivers,
                    self.editableDivId
                );
            }, 300);
        },
        send() {
            if (this.isOkDisabled) {
                return null;
            }

            this.isLoading = true;

            let params = {
                id: this.payment.id,
                client_id: this.client.id,
                timestamp: this._now().toFormat("X"),
                subject: this.subject,
                message: this.message,
                to: []
            };

            if (this.selectedReceivers.length > 0) {
                forEach(this.selectedReceivers, function (element) {
                    params.to.push(element.to_id);
                });
            } else {
                return null;
            }

            BillingPaymentServices.emailReceipt(params)
                .then(response => {
                    if (response.code == 200) {
                        this._message(response.message);
                    } else {
                        this._message(response.message, "danger");
                    }

                    this.close();
                })
                .catch(error => {
                    this.close();
                    this._message("Error : Unable to email receipt", "danger");
                    console.error(error);
                });
        },
        close() {
            this.isLoading = false;
            this.$refs.modalEmailPayment.hide();
        }
    }
};
</script>
